export const CLASS_STREAMS = [
  "A", "B", "C", "D", "E", "F", "G", "H"
];